import Vue from "vue";
import store from "../../store";

Vue.prototype.$permission = function(permission) {
  if (store.state.selfInfo.role_name == "administrator") {
    return true;
  }
  if (permission == "admin") return false;
  if (store.state.permissions.indexOf(permission) != -1) {
    return true;
  } else {
    return false;
  }
};
